import "core-js/modules/es.array.map.js";
import { Core } from "@faire/design-tokens";
import { pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { useStrictLocalization } from "@faire/web/common/localization";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { Anchor } from "@faire/web/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
import { policyLinks } from "./footerContent";
export var PolicyLinks = function PolicyLinks() {
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var linkVariant = isMobile ? "labelSansRegular" : "paragraphSansRegular";
  return /*#__PURE__*/React.createElement(PolicyLinksWrapper, null, policyLinks(strictLocalize).map(function (link, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: link.path
    }, index === 0 ? null : /*#__PURE__*/React.createElement(PolicyLinkSeparator, null), /*#__PURE__*/React.createElement(PolicyLink, {
      href: link.path
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: linkVariant
    }, link.text)));
  }));
};
var PolicyLinksWrapper = styled.div.withConfig({
  displayName: "PolicyLinks__PolicyLinksWrapper"
})(["display:flex;", "{padding:0 24px 24px;flex-wrap:wrap;gap:", ";}", "{padding:20px 56px;flex-direction:row;flex-wrap:nowrap;gap:", ";}", "{gap:", ";}", ""], responsiveMediaQueries.mobile, getSpacing("1x"), responsiveMediaQueries.tabletAndAbove, getSpacing("2x"), responsiveMediaQueries.desktopAndAbove, getSpacing("3x"), pageMaxWidthCss);
var PolicyLinkSeparator = styled.span.withConfig({
  displayName: "PolicyLinks__PolicyLinkSeparator"
})(["display:block;width:1px;background:", ";"], Core.border.muted);
var PolicyLink = styled(Anchor).withConfig({
  displayName: "PolicyLinks__PolicyLink"
})(["", "{white-space:nowrap;}> p{color:", ";}&:hover > p{color:", ";}"], responsiveMediaQueries.tabletAndAbove, Core.text.subdued, Core.text.hover);